// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentActivities_container__QOtZ9","activities":"RecentActivities_activities__2oDc2"};